<div class="event-info">
    <div class="font-size-125rem bold">{{event().title}}</div> 
    @if (type() == "projectView") {
        <div>{{app.t('entity.CalendarEvent.fields.contactPerson')}}: {{getContactPersonText()}}</div>             
        <div>{{app.t('entity.CalendarEvent.fields.editor')}}: {{getUserNameText()}}</div>             
        <div>{{getDate()}}</div>             
        <div class="event-note">{{noteText()}}</div>
        <div>{{getResourcesText()}}</div>  
    }
    @else {
        @if (event().kind == _CalendarEventKind.appointment) {
            <div>{{getCreatedByText()}}</div>             
        }
        @else {
            <div>{{getProjectNumber()}}</div> 
            <div>{{getProjectTitle()}}</div> 
            <div>{{app.t('entity.CalendarEvent.fields.contactPerson')}}: {{getContactPersonText()}}</div>             
            <div>{{app.t('entity.CalendarEvent.fields.editor')}}: {{getUserNameText()}}</div>             
        }
        <div>{{getDate()}}</div>             
        @if (event().kind == _CalendarEventKind.appointment) {
            <div>{{app.t('entity.CalendarEvent.fields.location')}}: {{event().location}}</div>   
        }
        <div class="event-note">{{noteText()}}</div>
        @if (event().kind == _CalendarEventKind.appointment) {
            <div>{{getParticipantsText()}}</div> 
        }
        <div>{{getResourcesText()}}</div>  
    }
    <div class="font-size-075rem">{{app.t('entity.EfCoreDbEntry.fields.modifiedBy')}}: {{getModifiedByText()}} {{event().modifyDate | date:'dd.MM.yyyy HH:mm:ss'}}</div>             
    <div class="font-size-075rem">{{app.t('entity.CalendarEvent.fields.id')}}: {{event().id}}</div>
</div>
